import { render } from "./field_type.vue?vue&type=template&id=7437ae52"
import script from "./field_type.vue?vue&type=script&lang=js"
export * from "./field_type.vue?vue&type=script&lang=js"

import exportComponent from "/home/docuseal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/template_builder/field_type.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7437ae52"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7437ae52', __exports__)) {
    api.reload('7437ae52', __exports__)
  }
  
  module.hot.accept("./field_type.vue?vue&type=template&id=7437ae52", () => {
    api.rerender('7437ae52', render)
  })

}


export default __exports__